interface Props {
  className?: string;
}
export const TransferIcon = ({ className }: Props) => {
  return (
    <svg
      width="23"
      height="15"
      viewBox="0 0 23 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M9.63122 14.2004L15.5858 14.2004L22.2847 7.50151L15.5858 0.802604L9.63122 0.802604L16.3301 7.50151L9.63122 14.2004ZM0.699349 14.2004L6.65393 14.2004L13.3528 7.50151L6.65393 0.802604L0.699349 0.802604L7.39826 7.50151L0.699349 14.2004Z"
        fill="var(--swapper-text-color)"
      />
    </svg>
  );
};
